module.exports = __webpack_public_path__ + "img/card-outline.f10b855d.svg";